/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_Trace_TitleInputs */

const vi_product_lot_detail_trace_title = /** @type {(inputs: Product_Lot_Detail_Trace_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy xuất nguồn gốc lô sản phẩm`)
};

/**

* @param {Product_Lot_Detail_Trace_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_trace_title = /** @type {((inputs?: Product_Lot_Detail_Trace_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_Trace_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_trace_title(inputs)
});